import { Heart, Mail, MapPin, Facebook, Instagram, Twitter } from 'lucide-react';
import { Link } from 'react-router-dom';
import { contactInfo } from '../mock';

export const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Mission */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_dallas-blankets/artifacts/fxcceetr_The%20Blanket%20Project%20Logo.png" 
                alt="The Blanket Project Logo"
                className="h-8 w-8 object-contain"
              />
              <div>
                <h3 className="text-xl font-bold">The Blanket Project</h3>
                <p className="text-sm text-gray-300">Covering the needy with God's love</p>
              </div>
            </div>
            <p className="text-gray-300 mb-4 text-sm leading-relaxed">
              Inspired by Matthew 25:35-36, we bring warmth, hope, and dignity to underprivileged 
              and underserved communities through tangible acts of service and Christ's love.
            </p>
            <div className="flex space-x-4">
              <a 
                href={contactInfo.socialMedia.facebook} 
                className="text-gray-400 hover:text-orange-400 transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a 
                href={contactInfo.socialMedia.instagram} 
                className="text-gray-400 hover:text-orange-400 transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a 
                href={contactInfo.socialMedia.twitter} 
                className="text-gray-400 hover:text-orange-400 transition-colors"
                aria-label="Twitter"
              >
                <Twitter className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="text-gray-300 hover:text-orange-400 transition-colors">About Us</Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-orange-400 transition-colors">Our Services</Link></li>
              <li><Link to="/volunteer" className="text-gray-300 hover:text-orange-400 transition-colors">Volunteer</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-orange-400 transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Info</h4>
            <div className="space-y-3 text-sm">
              <div className="flex items-start space-x-2">
                <MapPin className="h-4 w-4 text-orange-400 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-gray-300">{contactInfo.address}</p>
                  <p className="text-gray-300">{contactInfo.city}</p>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="h-4 w-4 text-orange-400 flex-shrink-0" />
                <a 
                  href={`mailto:${contactInfo.email}`} 
                  className="text-gray-300 hover:text-orange-400 transition-colors"
                >
                  {contactInfo.email}
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-gray-400 mb-2 md:mb-0">
              © {new Date().getFullYear()} The Blanket Project. All rights reserved.
            </p>
            <p className="text-sm text-gray-400">
              "For I was hungry and you gave me something to eat..." - Matthew 25:35
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};